// extracted by mini-css-extract-plugin
export default {"input":"InputField_input__G+A1Y","pink":"InputField_pink__H3HRU","blue":"InputField_blue__+78VY","orange":"InputField_orange__eCK0Z","green":"InputField_green__yx0a0"};